import type { Feature } from 'geojson';

export const deleteNoNeedProperties = (feature: Feature): Feature => {
  if (!feature.properties) { return feature; }

  const properties = feature.properties;
  delete properties['clustered'];
  delete properties['point_count'];
  delete properties['sqrt_point_count'];
  delete properties['point_count_abbreviated'];
  delete properties['iconImage'];
  delete properties['_title'];
  delete properties['title'];
  delete properties['FID'];
  delete properties['dmCode'];
  delete properties['アイテムID'];
  delete properties['ID'];
  delete properties['Location'];
  delete properties['Locations'];
  delete properties['fill'];
  delete properties['marker-symbol'];
  delete properties['fill-opacity'];
  delete properties['stroke'];
  delete properties['stroke-width'];
  delete properties['stroke-opacity'];
  delete properties['marker-color'];
  delete properties['stroke'];
  delete properties['color'];
  /*以下は路線網図のデータを用意後に削除する*/
  delete properties['CHIBUTSU'];
  delete properties['NFONTSIZE'];
  delete properties['NLABELANGL'];
  delete properties['NSYMBOLANG'];
  delete properties['NSYMBOLID'];
  delete properties['NSYMBOLSIZ'];
  delete properties['KEY'];
  delete properties['UserID'];
  delete properties['NLEVEL'];
  delete properties['Shape_Leng'];
  delete properties['FC'];
  /*以下は道路台帳図のデータを用意後に削除する*/
  delete properties['Before'];
  delete properties['FCOrg'];
  delete properties['Mapno'];
  delete properties['SplitKEY'];
  delete properties['new'];
  delete properties['Move'];
  delete properties['Found'];
  delete properties['rosen'];
  delete properties['zumen'];
  delete properties['Text'];

  return feature;
}